import React, { useEffect } from "react";
import { withRouter, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import { Button } from "cxa-components";
import { StringField, SelectField } from "cxa-form-field";
import { injectIntl, intlShape } from "react-intl";
import { CardSection } from "@cxagroup/casper/lib/components";
import { useSelector } from "react-redux";
import {
  EMAIL_TOKEN_ERROR_KEY,
} from "./constants";
import messages from "../messagesDescription";

const validateRequired = (value, values, { intl: { formatMessage } }) =>
  value ? null : formatMessage("Required");

const TitleSection = ({twoFaModes, intl}) => {
  const defaultMode = twoFaModes.find(mode => mode.isDefault);
  return (
    <section>
      <p className="fa-message-layout">
        <strong>{intl.formatMessage(messages.twoFaSetupTitle)}</strong>
      </p>
      <p className="fa-message-layout">
        <strong>{intl.formatMessage(messages.twoFaSetupMessage1)}</strong>{" "}
        <strong className="two-fa-highlight">
          {intl.formatMessage({ id: defaultMode.twoFaMode, defaultMessage: defaultMode.twoFaMode })}
        </strong>
      </p>
      <p>{intl.formatMessage(messages.twoFaSetupMessage2)}</p>
    </section>
  );
};

const FormFields = ({ isNewUI, countryCodeList, intl }) => {
  const transformedCountryCodeList = countryCodeList.map((item) => {
    const label = item.label.trim();
    const labelKey = `${item.value.split('+')[0]}`;
    const phoneCode = label.match(/\(\s?\+\d+\s?\)/)[0];
    return {
      ...item,
      label: `${intl.formatMessage({ id: labelKey, defaultMessage: labelKey })} ${phoneCode}`,
    };
  });

  return (
  <div
    className={isNewUI ? "setup-form-container-pp" : "setup-form-container"}
    style={{ display: "flex" }}
  >
    <div className="field-container">
      <SelectField
        label={intl.formatMessage(messages.loginCountryCode)}
        name="countryCode"
        items={transformedCountryCodeList}
        validate={validateRequired}
        boxed
      />
    </div>
    <div className="field-container">
      <StringField
        intl={intl}
        label={intl.formatMessage(messages.loginMobilePhoneNumber)}
        name="mobileNo"
        autoCorrect="off"
        autoCapitalize="none"
        validate={validateRequired}
        boxed
      />
    </div>
  </div>
  )
}


const ErrorMessage = ({ validationError, intl }) => (
  <div className="error-container">
    {validationError &&
    validationError.messageKey &&
    validationError.messageKey == EMAIL_TOKEN_ERROR_KEY
      ? intl.formatMessage(messages.emailTokenErrorMessage)
      : validationError
      ? validationError.message
      : ""}
  </div>
);

const LoginButton = ({ isNewUI, intl }) => (
  <Button primary className={isNewUI ? "form-btn-pp" : "form-btn"} to="/logout">
    {intl.formatMessage(messages.backToLoginButton)}
  </Button>
);

const VerificationButton = ({ isNewUI, intl }) => (
  <Button primary className={isNewUI ? "form-btn-pp" : "form-btn"}>
    {intl.formatMessage(messages.sendVerificationCodeBtn)}
  </Button>
);

const SetupTwoFAForm = ({
  initialValues,
  get2FACountryCodes,
  twoFACountryCodes,
  otp,
  get2FASettings,
  handleSubmit,
  validationError,
  intl,
  client,
  twoFaModes,
}) => {
  const clientId = client || initialValues.companyId;
  useEffect(() => {
    get2FACountryCodes(clientId);
    get2FASettings(clientId, initialValues.requestToken);
  }, [clientId]);

  const isNewUI = useSelector(state => state.common.clientSettings.newUIFlag);

  return otp.expireInSeconds ? (
    <Redirect to="/verify2fa" />
  ) : (
    <CardSection>
      <TitleSection twoFaModes={twoFaModes} intl={intl} />
      <form className="cxa-c-form" onSubmit={handleSubmit}>
        <FormFields isNewUI={isNewUI} countryCodeList={twoFACountryCodes} intl={intl} />
        <ErrorMessage validationError={validationError} intl={intl} />
        {validationError && validationError.messageKey == EMAIL_TOKEN_ERROR_KEY ? (
          <LoginButton isNewUI={isNewUI} intl={intl} />
        ) : (
          <VerificationButton isNewUI={isNewUI} intl={intl} />
        )}
      </form>
    </CardSection>
  );
};

SetupTwoFAForm.propTypes = {
  initialValues: PropTypes.object.isRequired,
  validationError: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  intl: intlShape.isRequired,
  twoFACountryCodes: PropTypes.array,
  otp: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  get2FACountryCodes: PropTypes.func.isRequired,
  get2FASettings: PropTypes.func.isRequired,
  client: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  twoFaModes: PropTypes.array,
};

FormFields.propTypes = {
  isNewUI: PropTypes.bool.isRequired,
  countryCodeList: PropTypes.array.isRequired,
  intl: intlShape.isRequired,
};

ErrorMessage.propTypes = {
  validationError: PropTypes.object,
  intl: intlShape.isRequired,
};

LoginButton.propTypes = {
  isNewUI: PropTypes.bool.isRequired,
  intl: intlShape.isRequired,
};

VerificationButton.propTypes = {
  isNewUI: PropTypes.bool.isRequired,
  intl: intlShape.isRequired,
};

TitleSection.propTypes = {
  twoFaModes: PropTypes.arrayOf(
    PropTypes.shape({
      twoFaMode: PropTypes.string.isRequired,
      isDefault: PropTypes.bool.isRequired
    })
  ).isRequired,
  intl: intlShape.isRequired,
};

export default withRouter(
  injectIntl(
    reduxForm({
      form: "setupTwoFAForm",
      enableReinitialize: true,
    })(SetupTwoFAForm)
  )
);



// WEBPACK FOOTER //
// ./components/twoFA/SetupTwoFAForm.js